import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact";
import {FacetAccordion} from "./elements";
import FacetItem from './FacetItem';

export default function FacetItemWrapper({ facet }) {
    const { active, toggleActive, toggleProductFilter } = useFacet(facet)

    return (
        <>
            <FacetAccordion 
                className="ns-only-mobile"
                id={facet.id}
                name={facet.name} 
                active={active} 
                onClick={toggleActive}>
                    <FacetItem facet={facet} toggleProductFilter={toggleProductFilter} />
            </FacetAccordion>
            <div className="ns-only-desktop ns-facets-item">
                <div className="ns-facets-item__title">
                    <span class="facets__summary-label font-secondary mono-lg lg-mono-sm">{facet.name}</span>
                </div>
                <div className="ns-facets-item__content">
                    <FacetItem facet={facet} toggleProductFilter={toggleProductFilter} />
                </div>
            </div>
        </>
    )
}
